import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import Card from '../Common/Card/Card'

import './ManageSupplier.scss'
import MobileHeader from '../Common/Header/MobileHeader'
import useCheckMobileScreen from '../../common/hooks/use-check-mobile-screen-hook'
import { convertToTitleCase } from '../../common/utils/appUtils'
import { navigate } from '../../common/utils/redirectionUtils'
import {
  ACTIVE_STATUS,
  PAGE_CONST,
  PERMISSION_FEATURE,
  PERMISSION_SCREEN,
  PERMISSION_TYPE,
  SUPPLIER_FIELDS,
} from '../../common/constant/page-constant'
import {
  HEADER_CONFIG,
  HEADER_CONST,
} from '../../common/constant/common-constant'
import SearchIcon from '../../assets/SearchIcon'
import CloseIcon from '../../assets/CloseIcon'
import {
  getAllSuppliersHelper,
  updateSupplierHelper,
} from '../../helper/settings-helper'
import './ManageSupplier.scss'
import SideDrawer from '../Common/SideDrawer/SideDrawer'
import Alert from '../../components/Alert/Alert'
import {
  addSupplierAlertAction,
  updateSupplierAlertAction,
} from '../../modules/actions/action'

const ManageSupplier = (props) => {
  const isMobile = useCheckMobileScreen()
  const inputRef = useRef()

  const [headerOptions, setHeaderOptions] = useState({
    [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
    [HEADER_CONFIG.TITLE]: HEADER_CONST.MANAGE_CUSTOMER,
    [HEADER_CONFIG.HANDLE_BACK_FUNC]: () => props?.onBackClick(),
  })
  const [loginData, setLoginData] = useState({})
  const [manageSupplierData, setManageSupplierData] = useState([])
  const [filteredManageSupplierData, setFilteredManageSupplierData] = useState(
    []
  )
  const [newSupplierData, setNewSupplierData] = useState({})
  const [viewSearch, setViewSearch] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [permissions, setPermissions] = useState({})
  const [open, setOpen] = useState(false)
  const [isFieldErrorVisible, setIsFieldErrorVisible] = useState(false)
  const [addSupplierAlert, setAddSupplierAlert] = useState(false)
  const [updateSupplierAlert, setUpdateSupplierAlert] = useState(false)
  const [isEditFlow, setIsEditFlow] = useState(false)

  useEffect(() => {
    getSupplierData()
  }, [])

  useEffect(() => {
    let addSupplierAlert = props.alert?.addSupplierAlert
    let updateSupplierAlert = props.alert?.updateSupplierAlert
    setAddSupplierAlert(addSupplierAlert)
    setUpdateSupplierAlert(updateSupplierAlert)
  }, [props.alert?.addSupplierAlert, props.alert.updateSupplierAlert])

  useEffect(() => {
    setLoginData(props.loginData)

    if (props.loginData.permissions) {
      console.log('props.loginData.permissions: ', props.loginData.permissions)

      let permission = props.loginData.permissions.filter(
        (permission) => permission.screen === PERMISSION_SCREEN.SETTINGS
      )[0]

      console.log('home screen permission: ', permission)
      if (permission) setPermissions(permission)
    }
  }, [props.loginData])

  useEffect(() => {
    let filteredStoreData = manageSupplierData.filter(
      (supplier) =>
        supplier?.mobile_no
          ?.toUpperCase()
          ?.includes(searchTerm?.toUpperCase()) ||
        supplier?.name?.toUpperCase()?.includes(searchTerm?.toUpperCase())
    )

    setFilteredManageSupplierData(filteredStoreData)
  }, [searchTerm])

  const getSupplierData = async () => {
    try {
      let data = await getAllSuppliersHelper()
      setManageSupplierData(data)
      setFilteredManageSupplierData(data)
    } catch (err) {
      console.log('err: ', err)
    }
  }

  const expandSearch = () => {
    inputRef.current.focus(setViewSearch(true))
  }

  const hanleCardAction = async (supplier, action) => {
    console.log('action clicked !!', action)

    let supplierData = {
      id: supplier.id,
      [SUPPLIER_FIELDS.NAME]: supplier.name,
      [SUPPLIER_FIELDS.PHONE_NUMBER]: supplier.mobile_no,
      [SUPPLIER_FIELDS.ADDRESS]: supplier.address,
    }

    if (action === 'EDIT') {
      setNewSupplierData({ ...supplierData })
      handleDrawerToggle()
      setIsEditFlow(true)
    } else {
      try {
        let status = action === ACTIVE_STATUS.ACTIVE

        supplierData.status = status
        await updateSupplierHelper(supplierData)
        getSupplierData()
      } catch (err) {
        console.log('err: ', err)
      }
    }
  }

  const checkValidation = () => {
    if (
      newSupplierData &&
      newSupplierData[SUPPLIER_FIELDS.NAME] &&
      newSupplierData[SUPPLIER_FIELDS.PHONE_NUMBER] &&
      newSupplierData[SUPPLIER_FIELDS.ADDRESS]
    ) {
      return true
    }

    return false
  }

  const handleSupplierDataUpdate = (key, value) => {
    setNewSupplierData({
      ...newSupplierData,
      [key]: value,
    })
  }

  const handleSubmit = async () => {
    if (!checkValidation()) {
      setIsFieldErrorVisible(true)
      return
    }

    setIsFieldErrorVisible(false)

    let data = { ...newSupplierData }
    console.log('data: ', data)

    try {
      let res = await updateSupplierHelper(data)

      console.log(res)

      if (isEditFlow) {
        setIsEditFlow(false)
        props.updateSupplierAlertAction(true)

        setTimeout(() => {
          props.updateSupplierAlertAction(false)
        }, 5000)
      } else {
        props.addSupplierAlertAction(true)

        setTimeout(() => {
          props.addSupplierAlertAction(false)
        }, 5000)
      }

      getSupplierData()
      resetDrawerData()
      handleDrawerToggle()
    } catch (err) {
      console.log(err)
    }
  }

  const handleDrawerToggle = () => {
    if (open) {
      resetDrawerData()
    }
    setOpen(!open)
  }

  const resetDrawerData = () => {
    setNewSupplierData({})
  }

  return (
    <>
      {isMobile && <MobileHeader headerOptions={headerOptions} />}
      {addSupplierAlert && (
        <Alert
          success
          alertType="success"
          alertMessage="New Supplier added Successfully!"
          onClose={() => props.addSupplierAlertAction(false)}
        />
      )}
      {updateSupplierAlert && (
        <Alert
          success
          alertType="success"
          alertMessage="Supplier updated Successfully!"
          onClose={() => props.updateSupplierAlertAction(false)}
        />
      )}
      <div className="pageBodyRightPanel">
        {isMobile && (
          <div className="addProductBtnMobile dFlex aiCenter mwebVisible fixed">
            <div
              className={'formGroup mb-0 searchBar expand'}
              onClick={expandSearch}
              onBlur={() => setViewSearch(false)}
            >
              <input
                ref={inputRef}
                type="text"
                className="formControl"
                placeholder="Search Supplier Name/Number"
                onChange={(e) => setSearchTerm(e?.target?.value)}
              />
              <div className={`searchIcon`}>
                <SearchIcon />
              </div>
            </div>
          </div>
        )}
        {!isMobile && (
          <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter mb-5">
            <div className="pageBodyRightPanelHeading">Manage Supplier</div>
            <div className="addProductBtn dFlex aiCenter">
              <div
                className={`formGroup mb-0 searchBar expand`}
                onClick={expandSearch}
                onBlur={() => setViewSearch(false)}
              >
                <input
                  ref={inputRef}
                  type="text"
                  className="formControl"
                  placeholder="Search Supplier Name/Number"
                  onChange={(e) => setSearchTerm(e?.target?.value)}
                />
                <div className={`searchIcon`}>
                  <SearchIcon />
                </div>
              </div>
              {permissions?.features?.[PERMISSION_FEATURE.SUPPLIER] ===
                PERMISSION_TYPE.MANAGE && (
                <button
                  className="btn btnPrimary ml-4"
                  onClick={handleDrawerToggle}
                >
                  ADD
                </button>
              )}
            </div>
            {/* <div className="addProductBtn dFlex aiCenter">
                            {permissions?.features?.[
                                PERMISSION_FEATURE.SUPPLIER
                            ] === PERMISSION_TYPE.MANAGE && (
                                <button
                                    className="btn btnPrimary"
                                    onClick={handleDrawerToggle}>
                                    ADD
                                </button>
                            )}
                            <div
                                className="pointer ml-4"
                                onClick={() => props.onClose()}>
                                <CloseIcon />
                            </div>
                        </div> */}
          </div>
        )}
        <div className="productLlistWrap dFlex">
          {filteredManageSupplierData?.map((supplier) => {
            return (
              <div className="cardWrap">
                <Card
                  userInitials={convertToTitleCase(supplier?.name?.[0])}
                  headerSup={supplier.name}
                  headerMain={`ID: ${supplier.id}`}
                  phone={supplier.mobile_no}
                  // email={supplier.email}
                  // rating={supplier.rating}
                  location={supplier.address}
                  {...(supplier.type !== 'EXTERNAL_USER' && {
                    isActive: supplier.is_active,
                  })}
                  cardAction={
                    permissions?.features?.[PERMISSION_FEATURE.SUPPLIER] ===
                      PERMISSION_TYPE.MANAGE &&
                    (supplier.type !== 'EXTERNAL_USER'
                      ? supplier.is_active
                        ? ['EDIT', ACTIVE_STATUS.INACTIVE]
                        : ['EDIT', ACTIVE_STATUS.ACTIVE]
                      : ['EDIT'])
                  }
                  onCardAction={(action) => hanleCardAction(supplier, action)}
                />
              </div>
            )
          })}
        </div>
        <SideDrawer
          handleDrawerToggle={handleDrawerToggle}
          open={open}
          downloadButton={true}
          downloadText={'Save'}
          drawerHeading="Add Supplier/Manufacturer"
          handleClick={() => handleSubmit()}
          sideDrawerFooter={
            <div className="download btn btnPrimary block">Save</div>
          }
        >
          <div className="wizardFieldset">
            <form className="mt-5">
              <div className="formGroup formFloating fgrow1">
                <input
                  type="text"
                  className="formControl"
                  id="custName"
                  placeholder="Supplier/Manufacturer Name*"
                  value={newSupplierData?.[SUPPLIER_FIELDS.NAME] || ''}
                  onChange={(e) =>
                    handleSupplierDataUpdate(
                      SUPPLIER_FIELDS.NAME,
                      e.target.value
                    )
                  }
                  required
                />
                <label for="invoice">Supplier/Manufacturer Name</label>
                {isFieldErrorVisible &&
                  !newSupplierData?.[SUPPLIER_FIELDS.NAME] && (
                    <div class="invalidFeedback">
                      Please enter Supplier/Manufacturer name.
                    </div>
                  )}
              </div>
              <div className="formInline dFlex flexNowrap">
                <div className="formGroup formFloating fgrow1 maxWidth">
                  <select className="formSelect" id="floatingSelect">
                    {/* <option value="1">+91</option> */}
                    <option value="2">+88</option>
                  </select>
                  <label for="floatingSelect">Country</label>
                  {false && (
                    <div class="invalidFeedback">
                      Please choose country code.
                    </div>
                  )}
                </div>
                <div className="formGroup formFloating ml-4 fgrow1">
                  <input
                    type="text"
                    className="formControl"
                    id="phone"
                    placeholder="Phone Number"
                    value={
                      newSupplierData?.[SUPPLIER_FIELDS.PHONE_NUMBER] || ''
                    }
                    onChange={(e) =>
                      handleSupplierDataUpdate(
                        SUPPLIER_FIELDS.PHONE_NUMBER,
                        e.target.value
                      )
                    }
                    required
                  />
                  <label for="phone">Phone Number</label>
                  {isFieldErrorVisible &&
                    !newSupplierData?.[SUPPLIER_FIELDS.PHONE_NUMBER] && (
                      <div class="invalidFeedback">
                        Please select a valid Phone Number.
                      </div>
                    )}
                </div>
              </div>
              <div className="formGroup formFloating">
                <input
                  type="text"
                  className="formControl"
                  id="billing"
                  placeholder="Address"
                  value={newSupplierData?.[SUPPLIER_FIELDS.ADDRESS] || ''}
                  onChange={(e) =>
                    handleSupplierDataUpdate(
                      SUPPLIER_FIELDS.ADDRESS,
                      e.target.value
                    )
                  }
                  required
                />
                <label for="address">Address</label>
                {isFieldErrorVisible &&
                  !newSupplierData?.[SUPPLIER_FIELDS.ADDRESS] && (
                    <div class="invalidFeedback">
                      Please enter a valid Address.
                    </div>
                  )}
              </div>
            </form>
          </div>
        </SideDrawer>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    alert: state.alertReducer.alert,
    loginData: state.loginDataReducer?.loginData,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addSupplierAlertAction: (payload) =>
      dispatch(addSupplierAlertAction(payload)),
    updateSupplierAlertAction: (payload) =>
      dispatch(updateSupplierAlertAction(payload)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageSupplier)
